import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

//Importing Modal
import ModalSection from '../../components/common/ModalSection';


class Section extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false
        }
        this.callModal.bind(this);
    }

    callModal = () => {
        this.refs.child.openModal();
    }
    
    render() {


        return (
            <React.Fragment>
                <section className="section bg-home home-half" id="home">
                    <div className="bg-overlay"></div>
                    <Container>
                        <Row>
                            <Col lg={{size : 12}} className="text-white text-center mb-5">
                                <h4 className="home-small-title text-primary">Welcome Aboard</h4>
                                <h1 className="home-title">We Handle Complex Web Development for Startups, Digital Agencies & Government Offices</h1>
                                <p className="padding-t-15 home-desc mx-auto text-muted">World class web app development built start to finish by a nimble team of elite software craftsman, UI/UX artisans and expert industry project consultants.</p>
                            </Col>
                            {/* Render ModalSection Component for Modal */}
                            <ModalSection ref="child" channel='vimeo' videoId='99025203' />
                        </Row>
                    </Container>
                    <div className="wave-effect wave-anim">
                        <div className="waves-shape shape-one">
                            <div className="wave wave-one" style={{ backgroundImage :`url(assets/images/wave-shape/wave11.png)`  }}></div>
                        </div>
                        <div className="waves-shape shape-two">
                            <div className="wave wave-two" style={{ backgroundImage :`url(assets/images/wave-shape/wave12.png)`  }}></div>
                        </div>
                        <div className="waves-shape shape-three">
                            <div className="wave wave-three" style={{ backgroundImage :`url(assets/images/wave-shape/wave13.png)`  }}></div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Section;